module.exports = __webpack_public_path__ + "static/media/bg_top.ccca4fac.png";